export default __webpack_public_path__ + "static/documentation-global-header-03-5032145f040a556153a63774790ab9de.jpg";